import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FormPage from './components/FormPage';
import ReceiptUploadPage from './components/ReceiptUploadPage';
import CFUDashboard from './components/CFUDashboard';
import AdminPage from './components/AdminPage';
import Login from './components/Login';
import TermsAndConditions from './components/TermsAndConditions';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<FormPage />} />
          <Route path="/receipt-upload" element={<ReceiptUploadPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/login" element={<Login />} />
          <Route 
            path="/cfu-dashboard" 
            element={
              <ProtectedRoute>
                <CFUDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
